import auth from "@/utils/auth.js";
import Tools from '@/utils/tools.js';
import axios from 'axios';
import ElementUI from 'element-ui';
import Qs from 'qs';
import kayak from '@/frame/kayak.js'

let httpUtil = {};

const basePath = getURL().baseUrl;
// const basePath = "http://10.1.9.15:8889/";

axios.defaults.timeout = 20000

httpUtil.basePath = basePath

httpUtil.comnUpdate = function(data) {
  let action = data.action;
  if (!action || action.indexOf(".") == -1) {
    return;
  }
  if (data.successAlert !== false) {
    data.successAlert = true;
  }
  let actions = action.split(".");
  data.url = "commUpdate/" + actions[0] + "/" + actions[1] + ".json";

  return httpUtil.ajax(data);
};

httpUtil.update = function(data) {
  if (data.successAlert !== false) {
    data.successAlert = true;
  }
  return httpUtil.ajax(data);
};

httpUtil.query = function(data) {
  data.mask = false;
  return httpUtil.ajax(data);
};

httpUtil.graphqlQurey = function(data) {
  let graphql = data.graphql;
  if (data.params) {
    let graphqlFirst = graphql.substring(0, graphql.indexOf(")"));
    let graphqlSecond = graphql.substring(graphql.indexOf(")"));
    for (var key in data.params) {
      if (!data.params[key] && data.params[key] !== 0) {
        continue;
      }
      if (typeof data.params[key] == "string") {
        graphqlFirst += "," + key + ": \"" + Tools.enterConvert(data.params[key], data.replaceQuotation) + "\"";
      } else {
        graphqlFirst += "," + key + ":" + data.params[key];
      }
    }
    graphql = graphqlFirst + graphqlSecond;
  }

  data.params = graphql;

  data.url = "graphql.json";
  data.mask = false;
  return httpUtil.ajaxJson(data);
};

httpUtil.graphqlUpdate = function(data) {
  let graphql = data.graphql;

  if (data.params) {
    let graphqlFirst = graphql.substring(0, graphql.indexOf(")"));
    let graphqlSecond = graphql.substring(graphql.indexOf(")"));
    for (var key in data.params) {
      if (!data.params[key] && data.params[key] !== 0) {
        continue;
      }
      if (typeof data.params[key] == "string") {
        graphqlFirst += "," + key + ": \"" + Tools.enterConvert(data.params[key], data.replaceQuotation) + "\"";
      } else {
        graphqlFirst += "," + key + ":" + data.params[key];
      }
    }
    graphql = graphqlFirst + graphqlSecond;
  }

  data.params = graphql;

  data.url = "graphql.json";
  data.mask = false;
  data.successAlert = true;
  return httpUtil.ajaxJson(data);
};

httpUtil.comnQuery = function(data) {
  let action = data.action;

  if (!action || action.indexOf(".") == -1) {

    return;
  }

  let actions = action.split(".");

  data.url = "commQuery/" + actions[0] + "/" + actions[1] + ".json";
  data.mask = false;
  return httpUtil.ajax(data);
};

httpUtil.comnQueryTree = function(data) {
  let action = data.action;
  if (!action || action.indexOf(".") == -1) {
    return;
  }
  let actions = action.split(".");
  data.url = "commTreeQuery/" + actions[0] + "/" + actions[1] + ".json";
  return httpUtil.ajax(data);
};

const return_code = '0000'

httpUtil.ajax = function(data) {

  return new Promise((resolve, reject) => {
    axios({
      method: "POST",
      url: basePath + data.url,
      data: Qs.stringify(data.params),
      headers: {
        'Content-type': 'application/x-www-form-urlencoded',
        'Authorization': auth.getToken()
      }
    }).then(res => {
      let reData = res.data;
      if (data.callback) {
        data.callback(reData);
      }

      if (reData.success || reData.status === '200' || reData.rtnCode === return_code || reData.rows) {
        if (reData.rtnCode) {
          Tools.alert(reData.rtnDesc || "操作成功");
        } else if (data.successAlert) {
          Tools.alert(reData.returnmsg || "操作成功");
        }

        if (data.dataAfterSuccess) {
          data.dataAfterSuccess(reData);
        }
        resolve(reData);
      } else {
        if (reData.login) {
          Tools.ssoOutLogin()
          return;
        }
        if (reData.token_freshen) {
          auth.setToken(reData.token);
          httpUtil.ajax(data).then(_data => {
            resolve(_data);
          });
          return;
        }
        if (data.errCallback) {
          data.errCallback(reData);
        } else {
          Tools.alert(reData.returnmsg || reData.rtnDesc || "操作失败", "danger");
          reject(reData)
        }
      }
    }).catch(function(err) {
      if (data.callback) {
        data.callback(err);
      }
      if(!data.isNoAlertMsg) {
        Tools.alert("服务器异常，请稍后尝试", "danger");
      }
      reject(err)
      console.log(err);

    });
  });
};



httpUtil.ajaxJson = function(data) {
  return new Promise((resolve, reject) => {
    axios({
      method: "POST",
      url: basePath + data.url,
      data: data.params,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'Authorization': auth.getToken()
      }
    }).then(res => {
      let reData = res.data;
      if (reData.success || reData.rtnCode === return_code || reData.rows) {
        if (reData.rtnCode) {
          Tools.alert(reData.rtnDesc || "操作成功");
        } else if (data.successAlert) {
          Tools.alert(reData.returnmsg || "操作成功");
        }
        if (data.dataAfterSuccess) {
          data.dataAfterSuccess(reData);
        }
        resolve(reData);
      } else {
        if (reData.login) {
          Tools.ssoOutLogin()
          return;
        }
        if (reData.token_freshen) {
          auth.setToken(reData.token);
          httpUtil.ajax(data).then(_data => {
            resolve(_data);
          });
          return;
        }
        if (data.errCallback) {
          data.errCallback(reData);
        } else {
          Tools.alert(reData.returnmsg || reData.rtnDesc || "操作失败", "danger");
        }
      }
    }).catch(function(err) {
      Tools.alert(reData.returnmsg || "服务器异常，请稍后尝试", "danger");
      console.log(err);
    });
  });
};

httpUtil.upload = function (data) {
  return new Promise((resolve, reject) => {
    let formData = new FormData();
    for (let i = 0; i < data.files.length; i++) {
      formData.append("files", data.files[i]);
    }
    axios({
      method: "POST",
      url: basePath + data.url,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data, charset=UTF-8',
        'Authorization': auth.getToken()
      }
    }).then(res => {
      let reData = res.data;
      if (reData.success || reData.status === '200' || reData.rtnCode === return_code || reData.rows) {
        if (reData.rtnCode) {
          Tools.alert(reData.rtnDesc || "操作成功");
        } else if (data.successAlert) {
          Tools.alert(reData.returnmsg || "操作成功");
        }
        if (data.dataAfterSuccess) {
          data.dataAfterSuccess(reData);
        }
        resolve(reData);
      } else {
        if (reData.login) {
          Tools.ssoOutLogin()
          return;
        }
        if (reData.token_freshen) {
          auth.setToken(reData.token);
          httpUtil.ajax(data).then(_data => {
            resolve(_data);
          });
          return;
        }
        if (data.errCallback) {
          data.errCallback(reData);
        } else {
          Tools.alert(reData.returnmsg || reData.rtnDesc || "操作失败", "danger");
        }
      }
    }).catch(err => {
      if (data.callback) {
        data.callback(err);
      }
      Tools.alert("服务器异常，请稍后尝试", "danger");
    })
  })
}

httpUtil.download = function(data, fileName) {

  let _ajaxUrl;
  if (data.url.indexOf("http") == -1) {
    _ajaxUrl = basePath + data.url;
  } else {
    _ajaxUrl = data.url;
  }

  if (!data.params) {
    data.params = {}
  }

  axios({
    method: 'post',
    url: _ajaxUrl,
    data: Qs.stringify(data.params),
    responseType: 'blob',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
      'Authorization': auth.getToken()
    }
  }).then(response => {
    if (data.callback) {
      data.callback(response);
    }
    if (!response) {
      return
    }

    let url = window.URL.createObjectURL(new Blob([response.data]));
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;

    let suffix = "";
    if (response.headers['filename']) {
      fileName = response.headers['filename']
    } else if (response.headers['content-disposition']){
      fileName = unescape(decodeURI(response.headers['content-disposition'].split(';')[1].split('filename=')[1]));
    }

    if (!fileName) {
      fileName = 'download' + suffix;
    }

    link.setAttribute('download', fileName);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

  }).catch((error) => {
    if (data.callback) {
      data.callback();
    }
    console.info(error);
  })
};

httpUtil.sysparam = function(paraid, moduleid = '0') {
  return new Promise((resolve, reject) => {
    httpUtil.comnQuery({
      action: "SystemParam.find",
      params: {
        moduleid: moduleid,
        paraid: paraid,
      }
    }).then(data => {
      if (data.rows && data.rows[0]) {
        resolve(data.rows[0].paravalue);
      } else {
        resolve();
      }
    }).catch(e => {
      reject(e);
    })
  });
}

httpUtil.dictCache = {};

httpUtil.dict = function(dict) {
  return new Promise((resolve, reject) => {
    let dt = httpUtil.dictCache[dict];
    if (dt == null) {
      let url = "base/dict/" + dict + ".json";
      httpUtil.ajax({
        url: url,
        mask: false
      }).then(data => {
        if (data.rows && data.rows.length > 0) {
          httpUtil.dictCache[dict] = data.rows;
        }
        return resolve(data.rows);
      });
    } else {
      return resolve(dt);
    }
  });
}

httpUtil.dictTransfer = function(dict, key) {
  return new Promise((resolve, reject) => {
    if (dict === null || dict === '' || key === null || key === '') {
      return resolve('');
    }
    httpUtil.dict(dict).then(rows => { //取得字典数据
      if (!rows || rows.length == 0) { //取不到字典数据
        return key;
      }

      let vals = [];
      let keys = String(key).split(',');
      let len = keys.length;

      keys.map(key => {
        let value = "";
        rows.map(row => {
          if (row.itemkey == key) {
            value = row.itemval;
          }
        });
        vals.push(value);
      });

      return resolve(vals.join('，'));
    });
  });
}

httpUtil.verifyCode = function (t) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: basePath + "verify/verifyCode.action",
      params: { t },
      responseType: 'blob',
    }).then(response => {
      resolve(window.URL.createObjectURL(new Blob([response.data])))
    }).catch((error) => {
      console.info(error)
    })
  })
}

export default httpUtil;



// WEBPACK FOOTER //
// ./src/frame/httpUtil.js